import { Task } from 'gantt-task-react'

export const MOCK_GANTT_CHART_DATA: Task[] = [
  {
    start: new Date(2023, 6, 8),
    end: new Date(2023, 6, 14),
    name: 'SO-1234',
    id: 'Task 1',
    type: 'project',
    progress: 45,
    isDisabled: true,
    styles: {
      backgroundColor: '#ff9e0d',
      progressColor: '#ffbb54',
      progressSelectedColor: '#ff9e0d',
    },
  },
  {
    start: new Date(2023, 6, 15),
    end: new Date(2023, 6, 17),
    name: 'SO-1234',
    id: 'Task 2',
    type: 'project',
    progress: 60,
    isDisabled: true,
    styles: {
      backgroundColor: '#246931',
      progressColor: '#4BA75D',
      progressSelectedColor: '#246931',
    },
  },
  {
    start: new Date(2023, 6, 17),
    end: new Date(2023, 6, 25),
    name: 'SO-1234',
    id: 'Task 3',
    type: 'project',
    progress: 10,
    isDisabled: true,
    styles: {
      backgroundColor: '#0272a1',
      progressColor: '#0096d4',
      progressSelectedColor: '#0272a1',
    },
  },
  {
    start: new Date(2023, 6, 25),
    end: new Date(2023, 6, 30),
    name: 'SO-1234',
    id: 'Task 4',
    type: 'project',
    progress: 20,
    isDisabled: true,
    styles: {
      backgroundColor: '#8f3806',
      progressColor: '#B54708',
      progressSelectedColor: '#8f3806',
    },
  },
]
